<template>
  <div
    class="hm-toggle-button"
    :class="{
      'hm-toggle-button--active': isActive,
    }"
    @click="toggleSelected"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HMToggleButton',
  props: {
    value: {
      type: Boolean,
    },
  },
  data() {
    return {
      isActive: this.value,
    };
  },
  methods: {
    toggleSelected() {
      this.isActive = !this.isActive;
      this.$emit('input', this.isActive);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.hm-toggle-button {
  user-select: none;
  background-color: $white;
  color: $dark-gray;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  &--active {
    background-color: var(--brand-color, $coral);
    color: white;
  }
}
</style>
